import { useContext } from "react";
import { AppContext } from "../App";
import { carePillars, hospitalInfo } from "../content/hospitalContent";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { FiShield, FiUsers, FiWind, FiPlus, FiGlobe, FiCpu, FiBarChart2, FiCheck, FiTarget, FiEye, FiLayers } from "react-icons/fi"; 
import banner1 from "../assets/banner2.jpg";
import banner2 from "../assets/banner1.jpg";
import { IoMdArrowForward } from "react-icons/io";

export default function HomeBanner3() {
  const appContext = useContext(AppContext);

  const getIcon = (title) => {
    const t = title.toLowerCase();
    if (t.includes("safety")) return <FiShield />;
    if (t.includes("team")) return <FiUsers />;
    if (t.includes("calm") || t.includes("comfort")) return <FiWind />;
    return <FiPlus />;
  };

  return (
    <>

      {/* Existing Section */}
      <section className="care-section">
        <div className="care-container">
          <header className="care-header">
            <span className="care-label">Healthcare Provision</span>
            <h2 className="care-title">
              Precision Medicine. <br/>
              <span>Empathetic Care.</span>
            </h2>
          </header>

          <div className="care-grid">
            <div className="care-pillars-list">
              {carePillars.map((pillar) => (
                <article key={pillar.title} className="pillar-item">
                  <div className="d-flex align-items-center gap-2">
                    <div className="pillar-icon-wrapper">{getIcon(pillar.title)}</div>
                    <h3 className="pillar-title">{pillar.title}</h3>
                  </div>
                  <p className="pillar-desc pt-2">{pillar.text}</p>
                </article>
              ))}
              <div className="care-cta-box">
                <button className="btn-modern" onClick={() => appContext.navTo({ item: "about_us" })}>
                  Discover More <HiOutlineArrowNarrowRight size={18} />
                </button>
              </div>
            </div>

            <div className="care-visuals">
              <div className="img-frame">
                <img src={banner1} className="img-main" alt="Facility" loading="lazy" />
              </div>
              <div className="img-sub-frame">
                <img src={banner2} className="img-sub" alt="Team" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
}